export enum ApplicationType {
    HD = 'HD',
    LAIF = 'LAIF',
    ZND = 'ZND',
    COFUS_DUNAV = 'COFUS_DUNAV',
    COFUS_GLOBOS = 'COFUS_GLOBOS',
    MCL = 'MCL',
}
